import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  importErrorsFeatureKey,
  ImportErrorState,
  selectAll,
} from '../reducers/admin.reducer';

export const selectImportErrorsState = createFeatureSelector<ImportErrorState>(
  importErrorsFeatureKey
);

export const selectAllImportErrors = createSelector(
  selectImportErrorsState,
  selectAll
);

export const selectImportErrorCurrentPage = createSelector(
  selectImportErrorsState,
  (state) => state.currentPage
);
